<template>
    <div class="header">
        <div class="mobile_btn_switch" @click="isShowMobileNav = true"></div>
        <div class="in">
            <a class="logo2" :href="webPath" target="_blank"><img :src="logoPath" alt=""/></a>
        </div>
        <router-link class="logo" to="/"><img src="../assets/images/logo.svg" alt=""/></router-link>
        <div class="in menu_wrap" :class="{active: isShowMobileNav}"> 
            <div class="close" @click="isShowMobileNav = false"></div>
            <div class="menu" :class="schoolName">
                <div class="links">
                    <!-- 其他 -->
                    <template>
                        <router-link class="btn" to="/iframe/contact" target="_blank" @click.native="$trackEvent('contact-us')">
                            <p>{{$t('contactUs')}}</p>
                            <img src="../assets/images/icon_email.png" alt="" class="icon"/>
                        </router-link>
                        <router-link class="btn" to="/iframe/scheduleavisit" target="_blank" @click.native="$trackEvent('schedule-visit')">
                            <p>{{$t('schduleAVisit')}}</p>
                            <img src="../assets/images/icon_eye.png" alt="" class="icon"/>
                        </router-link>
                        <router-link class="btn" to="/iframe/apply" target="_blank" @click.native="$trackEvent('apply-now')">
                            <p>{{$t('applyNow')}}</p>
                            <img src="../assets/images/icon_edit.png" alt="" class="icon"/>
                        </router-link>
                    </template>
                </div>
                <div class="btn_close" @click="isShowMobileNav = false"></div>
                <!-- years -->
                <div class="item" v-for="(item, index) in years" :key="index" :class="{active: yearsCheckedIndex == index}" @click="showYearsPopup(index)">{{item.name}}</div>
                <template v-if="!isOnlyEnglish">
                    <a class="item lange" :href="($i18n.locale == 'en' ? `/${schoolName}${isHighSchool ? '' : '/zh'}` : `/${schoolName}${isHighSchool ? '/en' : ''}`) + $route.fullPath">
                        <span :class="{active: $i18n.locale == 'en'}">EN</span>
                        <span>&nbsp;I&nbsp;</span>
                        <span :class="{active: $i18n.locale == 'zh'}">中文</span>
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
export default {
    name: "Header",
    data() {
        return {
            APP_NAME: process.env.VUE_APP_NAME,
            schoolName: process.env.VUE_APP_NAME,
            logoPath: require('../assets/images/logo2_' + process.env.VUE_APP_NAME + '.svg'),
            isOnlyEnglish: process.env.VUE_APP_IS_ONLY_ENGLISH == '1',
            isHighSchool: process.env.VUE_APP_IS_HIGH_SCHOOL == '1',
            isShowMobileNav: false,
        };
    },
    computed: {
        ...mapState(['years', 'yearsCheckedIndex']),
        webPath(){
            let url = process.env.VUE_APP_WEBURL;
            if(this.$i18n.locale == 'zh'){
                url += '/zh';
            }
            return url;
        }
    },
    components: {
    },
    mounted() {
        
    },
    watch: {},
    methods: {
        showYearsPopup(index){
            this.isShowMobileNav = false;
            this.$store.state.isShowYearsPopup = true;
            this.$store.state.yearPageActiveIndex = 1;
            this.$store.state.yearsActiveIndex = index;
            // trackEvent
            let gaLabels = ['menu-ducks', 'menu-js', 'menu-ss'];
            // 新加坡有四个
            // if (this.schoolName == 'singapore') { 
            //     gaLabels.push('menu-te');
            // }
            this.$trackEvent(gaLabels[index]);
        },
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">
.header{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: .8rem;
    padding: 0 .5rem;
    background: #fff;
    display: flex;
    align-items: center;
    z-index: 9999;
    .in{
        flex: 1;
        img{
            width: 100%;
        }
    }
    .logo{
        width: .45rem;
        display: block;   
    }
    .logo2{
        width: 3.35rem;
        display: block;
    }
    .menu{
        display: flex;
        justify-content: flex-end;
        font-size: .16rem;
        font-weight: bold;
        .btn_close{
            display: none;
        }
        &.singapore{
            .item{
                margin-left: .4rem;
            }
        }
        .item{
            cursor: pointer;
            margin-left: .5rem;
            &:first-child{
                margin-left: 0;
            }
            &.lange{
                .active{
                    color: #999;
                }
            }
            &.active{
                text-decoration: underline;
            }
        }
        .links{
            position: fixed;
            top: 1.5rem;
            left: 0;
            z-index: 1;
            width: 0;
            .btn{
                width: 2rem;
                height: .56rem;
                border-radius: 0 .15rem .15rem 0;
                padding: 0 .16rem 0 .24rem;
                color: #fff;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: .12rem;
                font-weight: bold;
                margin-bottom: .1rem;
                cursor: pointer;
                transition: transform .5s;
                transform: translate3d(-70%, 0, 0);
                &:hover{
                    transform: translate3d(0, 0, 0);
                }
                .icon{
                    width: .36rem;
                }
                &:nth-of-type(1){
                    background: #97d701;
                }
                &:nth-of-type(2){
                    background: #762954;
                }
                &:nth-of-type(3){
                    background: #ff5100;
                }
            }
        }
    }
    @media only screen and (orientation: landscape) and (max-width: 1023px) {
        display: none;
    }
    @media only screen and (max-width: 640px) {
        height: 1.2rem;
        padding: 0 .36rem 0 0;
        .mobile_btn_switch{
            width: 1.2rem;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            &::after{
                content: "";
                display: block;
                width: .5rem;
                height: .43rem;
                background: url('../assets/images/icon_nav_switch.png') no-repeat 0/100%;
            }
        }
        .menu_wrap{
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 999;
            opacity: 0;
            visibility: hidden;
            transition: opacity .3s, visibility .3s;
            .close{
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }
            &.active{
                opacity: 1;
                visibility: visible;
                .menu{
                    transform: translate(0, 0);
                }
            }
            .menu{
                width: 5rem;
                height: 100%;
                flex-direction: column;
                color: #fff;
                justify-content: start;
                position: relative;
                padding-top: 1.8rem;
                background: rgba($color: #000000, $alpha: 0.8);
                transform: translate(-100%, 0);
                transition: transform .3s;
                font-size: .3rem;
                .btn_close{
                    display: block;
                    position: absolute;
                    top: .36rem;
                    left: .36rem;
                    width: .42rem;
                    height: .42rem;
                    background: url('../assets/images/icon_close.png') no-repeat 0/100%;
                }
                .item{
                    margin-left: 0;
                    height: 1.3rem;
                    border-bottom: 1px solid rgba($color: #fff, $alpha: .1);
                    display: flex;
                    align-items: center;
                    padding-left: .36rem;
                }
            }
            .links{
                position: absolute;
                left: 0;
                top: auto;
                bottom: 1.2rem;
                right: 0;
                width: 100%;
                .btn{
                    transition: none;
                    transform: none;
                    width: 4.2rem;
                    height: .8rem;
                    border-radius: .05rem;
                    font-size: .3rem;
                    justify-content: center;
                    margin: 0 auto .4rem;
                    .icon{
                        display: none;
                    }
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
            }
        }
        .logo{
            width: .64rem;
        }
        .logo2{
            width: 4rem;
        }
    }
}
</style>